import { Fragment, memo, ReactElement, useEffect, useMemo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { Check, Close, ExpandMore } from '@mui/icons-material';
import Form from './form';
import { PersonalDataVM } from 'shell/view-models/personal-data';
import { FormikErrors } from 'formik';
import { AccordionGeneralityForm } from 'shell/view-models/accordion-generality-form';

interface AccordionFilterProps {
  onChange: (key: keyof PersonalDataVM, value: PersonalDataVM[keyof PersonalDataVM]) => void;
  values?: PersonalDataVM;
  disabled?: boolean;
  resetForm?: () => void;
  onChangeFields: (values: PersonalDataVM) => void;
  onSearch: () => void;
  errors?: FormikErrors<PersonalDataVM>;
  isOpenStartAccordion?: boolean;
}

const AccordionFilterComponent = ({
  onChange,
  values,
  disabled,
  resetForm,
  onChangeFields,
  onSearch,
  errors,
  isOpenStartAccordion,
}: AccordionFilterProps): ReactElement => {
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    if (isOpenStartAccordion) {
      setOpen(true);
    }
  }, []);

  useEffect(() => {
    if (disabled) {
      setOpen(false);
    }
  }, [disabled]);

  const hasErrors = useMemo(() => {
    if ((errors?.generality as FormikErrors<AccordionGeneralityForm>)?.fiscalCode) {
      return true;
    }
    return false;
  }, [errors]);

  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="filter"
          id="filter"
          classes={{
            root: 'pmi-flex-row-reverse',
          }}
          expandIcon={<ExpandMore />}
        >
          {errors ? hasErrors ? <Close color="error" /> : <Check color="success" /> : undefined}
          <Typography>Filtri</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Form
            onChange={onChange}
            errors={errors}
            values={values}
            resetForm={resetForm}
            disabled={disabled}
            onChangeFields={onChangeFields}
            onSearch={() => {
              setOpen(false);
              onSearch();
            }}
          />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

AccordionFilterComponent.displayName = 'Filtri persona';

const AccordionFilter = memo(AccordionFilterComponent);

export default AccordionFilter;
